import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/mvv/Mvv'

const Brands: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'ミッション mission ビジョン vision バリュー value'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/mvv/'}
        title="当社が目指しているもの | 私たちについて | i3DESIGN アイスリーデザイン"
        description="i3DESIGN（アイスリーデザイン）が果たすべき使命、目指す姿、私たちが大切にする価値について紹介しています。"
      />
      <Template />
    </>
  )
}

export default Brands
